module.exports = __webpack_public_path__ + "media/src/images/partners/hertie-51fdfa4c8beed2e72226cefb70128e22.jpg";